import React from "react";
import CompleteTemplates from "../../../../templates/Crew/Cargo/Complete";
import Default from "../../../../layouts/DefaultCrew";

const Complete = (): React.ReactElement => {
  return (
    <Default title="" selectedTitle={"Cargo"}>
      <CompleteTemplates action={"Update"} />
    </Default>
  );
};

export default Complete;
